import React from 'react';

class DebugOverlay extends React.Component {
  render() {
    return (
      <div className='b-debug-overlay'>
        {this.props.logLines.map(line => {
          return (
            <div className='log-line'>
              <span>{line}</span>
            </div>
          );
        })}
      </div>
    );
  }
}

export default DebugOverlay;
